import styled, { StyledComponent } from '@emotion/styled';
import { display, DisplayProps, height, HeightProps, width, WidthProps, color, ColorProps, space, SpaceProps } from 'styled-system';
import { ComponentProps } from 'react';

type HorizontalRuleProps = DisplayProps & HeightProps & WidthProps & ColorProps & SpaceProps;

const HorizontalRule: StyledComponent<ComponentProps<'hr'>, HorizontalRuleProps, any> = styled.hr`
  border: 0;
  ${display}
  ${width}
  ${height}
  ${width}
  ${color}
  ${space}
`;

HorizontalRule.defaultProps = {
  height: 'borderThin',
  bg: 'greys.alto',
};

HorizontalRule.displayName = 'HorizontalRule';

export default HorizontalRule;
